module.exports = __webpack_public_path__ + "88d2bd63ed6ebc9c7bcc5cf5290575ce.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/Lankenau.jpg
// module id = 760
// module chunks = 0